export enum Environment {
  Staging = "staging",
  Developing = "developing",
  Testing = "testing"
}